
import { Flex, Input, VStack } from "@chakra-ui/react";
import { useRef, useEffect } from "react";


type TProps = {
    [key: string]: any;
    inputs: string[];
    isDisabled?: boolean;
    setInputs: (inputs: string[]) => void;
}



const BulletPoints: React.FC<TProps> = ({ inputs, setInputs, isDisabled, ...rest }) => {
    const refs = useRef<Array<HTMLInputElement | null>>([]);

    useEffect(() => {
        refs.current = refs.current.slice(0, inputs.length);
    }, [inputs.length]);

    const handleChange = (value: string, index: number) => {
        const updated = [...inputs];

        if (index === inputs.length - 1 && value !== "") {
            updated.push("");
        }
        if (value === "" && index !== 0 && updated[index] === "") {
            if (index !== inputs.length - 1) {
                updated.splice(index, 1);
            }
            setTimeout(() => {
                const prevRef = refs.current[index - 1];
                prevRef?.focus();
            }, 0);
        }
        else
            updated[index] = value;
        setInputs(updated);
    };

    const handleEnter = (
        e: React.KeyboardEvent<HTMLInputElement>,
        index: number
    ) => {
        if (e.key === "Enter") {


            if (!inputs[index]) return;

            if (index < inputs.length - 2 && inputs[index] !== "") {
                const updated = [...inputs];
                updated.splice(index + 1, 0, "");
                setInputs(updated);
            }

            setTimeout(() => {
                const nextRef = refs.current[index + 1];
                nextRef?.focus();
            }, 0);
        }
        if (e.key === "ArrowDown") {
            e.preventDefault();
            if (inputs[index] === "" && index !== inputs.length - 1) {
                const updated = [...inputs];
                updated.splice(index, 1);
                setInputs(updated);
                setTimeout(() => {
                    const nextRef = refs.current[index];
                    nextRef?.focus();
                }, 0);
                return;
            }
            const nextRef = refs.current[index + 1];
            nextRef?.focus();
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            if (inputs[index] === "" && index !== inputs.length - 1) {
                const updated = [...inputs];
                updated.splice(index, 1);
                setInputs(updated);
                setTimeout(() => {
                    const prevRef = refs.current[index - 1];
                    prevRef?.focus();
                }, 0);
                return;
            }
            const prevRef = refs.current[index - 1];
            prevRef?.focus();
        }
        if (e.key === "Backspace") {
            if (inputs[index] === "" && index !== 0) {
                if (index !== inputs.length - 1) {
                    const updated = [...inputs];
                    updated.splice(index, 1);
                    setInputs(updated);
                }
                setTimeout(() => {
                    const prevRef = refs.current[index - 1];
                    prevRef?.focus();
                }, 0);
            }
        }
    };


    const onClickBullet = (index: number) => {
        const ref = refs.current[index];
        ref?.focus();
    }


    const onInputClick = (index: number) => {

        const updated = inputs.filter((input, i) => {
            if (input === "" && i !== index && i !== inputs.length - 1) {
                return false;
            }
            return true;
        });

        setTimeout(() => {
            const ref = refs.current[index];
            ref?.focus();
        }, 0);


        setInputs(updated);
    }

    return (
        <VStack width="100%" {...rest} fontSize="sm" alignItems="flex-start" maxH="100px" overflowY="scroll" >
            {inputs.map((value, index) => (
                <Flex >
                    <span
                        onClick={() => onClickBullet(index)}
                        style={{
                            fontSize: "22px",
                            lineHeight: "20px",
                            padding: "0 10px",
                            color: !value && refs.current[index] !== document.activeElement ? '#ccc' : '#555',
                            cursor: "pointer",
                        }}

                    >•</span>

                    <Input
                        isDisabled={isDisabled}
                        key={index}
                        ref={(el) => {
                            refs.current[index] = el;
                        }}
                        value={value}
                        minWidth="100%"
                        paddingLeft="0px"
                        color="#272525"
                        variant="unstyled"
                        onClick={() => onInputClick(index)}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyDown={(e) => handleEnter(e, index)}
                    />
                </Flex>
            ))}
        </VStack>
    );
}


export default BulletPoints;
